import ASTBlock from "../ASTBlock";
import Blockly from 'blockly';

export default class AlvikRotate extends ASTBlock {
    constructor(color) {
        super(color, "alvik_rotate")
        this.predefinedInputs = {
            "degree": {
                "block": {
                    "type": "number",
                    "fields": {
                        "value": 0
                    }
                }
            }
        }
        this.TOP_LEVEL = undefined
    }

    addToBlockly() {
        var json = {
            "tooltip": "",
            "helpUrl": "",
            "message0": "drehe nach %1 um %2 ° %3",
            "args0": [{
                    "type": "field_dropdown",
                    "name": "direction",
                    "options": [
                        [
                            "links",
                            "+"
                        ],
                        [
                            "rechts",
                            "-"
                        ]
                    ]
                },
                {
                    "type": "input_value",
                    "name": "degree",
                    "check": "Number"
                },
                {
                    "type": "input_dummy",
                    "name": "NAME"
                }
            ],
            "previousStatement": null,
            "nextStatement": null
        }

        let that = this
        Blockly.Blocks[this.name] = {
            init: function() {
                this.jsonInit(json);
                this.setColour(that.color)
            }

        }
    }
}